import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="dropdown"
export default class extends Controller {
  static targets = ["trigger", "content"];

  connect() {}

  toggle() {
    this.contentTarget.classList.toggle("hidden");
  }

  hide(event) {
    const triggerClicked = this.triggerTarget.contains(event.target);

    if (triggerClicked) {
      return;
    }

    this.contentTarget.classList.add("hidden");
  }

  // TODO: move this methods pls
  multipleToggle(event) {
    const contentId = this.contentTarget
      .querySelector("[data-dropdown-id]")
      ?.getAttribute("data-dropdown-id");
    const buttonId = event.currentTarget.getAttribute("data-dropdown-id");
    if (
      contentId !== buttonId &&
      !this.contentTarget.classList.contains("hidden")
    )
      return;
    this.contentTarget.classList.toggle("hidden");
  }

  closeOnOutsideClick(event) {
    if (this.element.contains(event.target)) return;
    this.contentTarget.classList.add("hidden");
  }
}
